import React from "react"
import { Card, CardBody, Row, Col } from "reactstrap"

const QuickStats = ({ data }) => {
  const stats = [
    {
      title: "Today's Registrations",
      value: data.newUsersToday || 45,
      icon: "mdi mdi-account-plus",
      color: "success",
      trend: "+12%"
    },
    {
      title: "Active Sessions",
      value: "2,340",
      icon: "mdi mdi-monitor-eye",
      color: "info",
      trend: "+8%"
    },
    {
      title: "Pending Reviews",
      value: data.pendingKYC || 23,
      icon: "mdi mdi-clock-outline",
      color: "warning",
      trend: "-5%"
    },
    {
      title: "System Alerts",
      value: "3",
      icon: "mdi mdi-alert-circle",
      color: "danger",
      trend: "0%"
    }
  ]

  return (
    <Row>
      {stats.map((stat, index) => (
        <Col xl={3} md={6} key={index}>
          <Card className="border-0 shadow-sm">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className={`avatar-sm rounded-circle bg-${stat.color} d-flex align-items-center justify-content-center me-3`}>
                  <i className={`${stat.icon} text-white`}></i>
                </div>
                <div className="flex-1">
                  <h5 className="mb-1">{stat.value}</h5>
                  <p className="text-muted mb-0 font-size-13">{stat.title}</p>
                </div>
                <div className={`text-${stat.trend.startsWith('+') ? 'success' : stat.trend.startsWith('-') ? 'danger' : 'muted'}`}>
                  <small>{stat.trend}</small>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  )
}

export default QuickStats